import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMinusCircleComponent } from "./med-icon-minus-circle.component";

@NgModule({
  declarations: [
    MedIconMinusCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMinusCircleComponent,
  ],
})
export class MedIconMinusCircleModule { }
